import React from "react";

import Checkbox from "components/MultiSelectDropdown/Checkbox";

import "./OrganizationDropdownOption.css";

export default function OrganizationDropdownOption(props) {
  const {
    option,
    onClick,
    selected,
    disabled,
    partiallySelected,
    isGroupHeader,
    isEmptyGroup,
    depth,
  } = props;
  const { value, label } = option;

  function getClassName() {
    const classNames = [
      selected
        ? "Organization-Dropdown-option--is-selected"
        : "Organization-Dropdown-option",
    ];

    if (isGroupHeader) {
      classNames.push("Organization-Dropdown-option--is-group-header");
    }

    if (depth > 0) {
      classNames.push("Organization-Dropdown-option--is-child");
    }

    if (disabled) {
      classNames.push("Organization-Dropdown-option--is-locked");
    }

    return classNames.join(" ");
  }

  function getTitle() {
    if (disabled) return "At least one parent company must stay selected";

    if (isGroupHeader) {
      // A group whose members have no parent companies cannot be narrowed, so its row must not
      // advertise one.
      if (isEmptyGroup) {
        return "Select this group - it has no parent companies to narrow it to";
      }

      return "Select this group and every parent company in it";
    }

    return undefined;
  }

  // A group's checkbox reports how much of it is in play: every parent company beneath it, some
  // of them, or none because a different organization is selected.
  function getCheckbox() {
    if (partiallySelected) {
      return <i className="fa fa-minus-square-o" />;
    }

    return <Checkbox checked={selected} />;
  }

  // The last remaining parent company cannot be deselected, so it is rendered as locked rather
  // than silently ignoring the click.
  return (
    <li
      className={getClassName()}
      key={value}
      onClick={() => onClick(option)}
      title={getTitle()}
    >
      <span className="Organization-Dropdown-option--checkbox">
        {getCheckbox()}
      </span>
      {label}
    </li>
  );
}
